module.exports = __webpack_public_path__ + "static/media/german_supply_600x378.ab50c929.jpg";